import { BikeRoute, ExternalMediaList, Ride, StatsCard } from '@geovelo-frontends/commons';
import { Box, Skeleton, Typography } from '@mui/material';
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../components/button';

interface IProps {
  bikeRoute: BikeRoute | null | undefined;
  rides: Ride[] | undefined;
}

export function DetailsTab({ bikeRoute, rides }: IProps): React.JSX.Element {
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation();

  const duration = rides?.reduce((res, { duration }) => res + (duration || 0), 0) || 0;

  return (
    <Box display="flex" flexDirection="column" padding={3}>
      <StatsCard
        enableDays
        hideCalories
        hideCO2Saved
        hideDuration
        showDistance
        showSteps
        data={
          bikeRoute
            ? {
                distance: bikeRoute.distance || 0,
                duration: Math.ceil(duration / (60 * 60 * 6)),
                nbSteps: bikeRoute.stepsCount,
              }
            : undefined
        }
      />
      <Box display="flex" justifyContent="center" marginY={3}>
        <Button
          color="primary"
          component={Link}
          disabled={!bikeRoute}
          to={`/${currentLanguage}/trip-planner?bike-route=${bikeRoute?.id}`}
          variant="contained"
        >
          {t('geovelo.bike_routes.detail.actions.plan_trip')}
        </Button>
      </Box>
      {bikeRoute ? (
        bikeRoute.description && <Typography variant="body2">{bikeRoute.description}</Typography>
      ) : (
        <Typography component="div" variant="body2">
          <Skeleton variant="text" width={300} />
        </Typography>
      )}
      {bikeRoute && bikeRoute.medias.length > 0 && <ExternalMediaList medias={bikeRoute.medias} />}
    </Box>
  );
}

export default DetailsTab;
